<template>
    <div class="mb-3" :class="sizeClassObject">
        <div v-if="claims.upcomingEvent.read" class="prl-0">
            <div class="card border-secondary">
                <div class="card-header pb-0">
                    <div class="btn-toolbar justify-content-between" role="toolbar">
                        <div>
                            <h5>
                                <i class="fas fa-globe-europe"></i>
                                {{ $t('eventsMap') }}
                            </h5>
                        </div>
                        <div>
                            <h5>
                                <button v-if="expanded" class="btn btn-link" @click.stop="sizeToggle">
                                    <i class="fas fa-compress-arrows-alt"></i>
                                </button>
                                <button v-else class="btn btn-link" @click.stop="sizeToggle">
                                    <i class="fas fa-expand-arrows-alt"></i>
                                </button>
                            </h5>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <events-map></events-map>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventsMap from '../maps/EventsMap';
    import { mapGetters } from 'vuex';
    import { DynamicLayoutPageSize } from '../../models/enums';

    export default {
        props: {
            size: Number
        },
        data() {
            return {
                expanded: this.size === 12,
            }
        },
        components: {
            EventsMap
        },
        computed: {
            sizeClassObject() {
                return this.$helpers.sizeClassObject(this.expanded ? DynamicLayoutPageSize.Max : Math.min(this.size, 6));
            },
            ...mapGetters(['claims'])
        },
        methods: {
            sizeToggle() {
                this.expanded = !this.expanded;
            }
        }
    }
</script>

<style>
    .prl-0 {
        padding-right: 0;
        padding-left: 0;
    }
</style>
